export default __webpack_public_path__ + "locales/sl/Translations.json?hash=bfae93ef8e2895932e556c4d51f6022f";